import ExportParks from '../pages/export/ExportParks'
import ExportCompanies from '../pages/export/ExportCompanies'
import ExportGeneralInformation from '../pages/export/ExportGeneralInformation'
import ExportParkQuiz from '../pages/export/ExportParkQuiz'

const routes = [
  {
    path: '/export/parks',
    name: 'ExportParks',
    component: ExportParks,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_RESEARCHER'],
      preLoad (to, authentication, router) {
        return new Promise((resolve, reject) => {
          if (authentication.userHasResearcherRole()) {
            resolve()
            return
          }
          reject()
          router.push({name: 'UnauthorizedError'})
        })
      }
    }
  },
  {
    path: '/export/companies',
    name: 'ExportCompanies',
    component: ExportCompanies,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_RESEARCHER'],
      preLoad (to, authentication, router) {
        return new Promise((resolve, reject) => {
          if (authentication.userHasResearcherRole()) {
            resolve()
            return
          }
          reject()
          router.push({name: 'UnauthorizedError'})
        })
      }
    }
  },
  {
    path: '/export/general-information',
    name: 'ExportGeneralInformation',
    component: ExportGeneralInformation,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_RESEARCHER'],
      preLoad (to, authentication, router) {
        return new Promise((resolve, reject) => {
          if (authentication.userHasResearcherRole()) {
            resolve()
            return
          }
          reject()
          router.push({name: 'UnauthorizedError'})
        })
      }
    }
  },
  {
    path: '/export/park-quiz',
    name: 'ExportParkQuiz',
    component: ExportParkQuiz,
    meta: {
      requiresAuthentication: true,
      roleRequired: ['ROLE_RESEARCHER'],
      preLoad (to, authentication, router) {
        return new Promise((resolve, reject) => {
          if (authentication.userHasResearcherRole()) {
            resolve()
            return
          }
          reject()
          router.push({name: 'UnauthorizedError'})
        })
      }
    }
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/export.js